window.AmbitionRuntime.register('hero-scroll', context => {
  const page = document.querySelector('.ambition-page');
  const hero = page?.querySelector('.hero');
  const heading = hero?.querySelector('.hero-heading');
  const copy = hero?.querySelector('.hero-copy');
  if (!heading || !copy) return;
  const cta = copy.querySelector('.cta');
  const focusTarget = heading.querySelector('h1') || heading;
  const focusTargetTabindex = focusTarget.getAttribute('tabindex');
  const header = page.querySelector('.ambition-header:not([data-ambition-dock])');
  const headerInert = header?.inert;
  const scrollHint = hero.querySelector('[data-hero-scroll-hint]');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  const range = (value, start, end) => clamp((value - start) / (end - start), 0, 1);
  const smooth = value => value * value * (3 - 2 * value);
  const easeOut = value => 1 - Math.pow(1 - value, 3);
  const navigation = performance.getEntriesByType('navigation')[0];
  const editing = Boolean(window.Shopify?.designMode);
  const bypass = Boolean(editing || (location.hash && location.hash !== '#inicio') || scrollY > 4 || navigation?.type === 'back_forward');
  let progress = page.dataset.heroRevealHeld || bypass ? 1 : 0;
  let state = progress ? 'done' : 'idle';
  let geometry = null, frame = 0, holdTimer = 0, arrivalStart = 0, transitionFrom = progress;
  let touch = null, previousScroll = scrollY, lastInput = 0, lastUpInput = 0, upwardDistance = 0;
  const active = () => state === 'arriving' || state === 'holding';
  const atTop = () => scrollY <= 2;
  page.classList.add('has-hero-scroll');
  hero.dataset.revealPause = state;

  function paint() {
    if (!geometry) return;
    const rise = easeOut(range(progress, .04, .78));
    const line = smooth(range(progress, .06, .6));
    const text = smooth(range(progress, .02, .6));
    const action = smooth(range(progress, .08, .8));
    const { headingStart, headingEnd, mobile, scaleStart, scaleEnd, hintStart, hintEnd } = geometry;
    hero.style.setProperty('--hero-heading-y', `${headingStart + (headingEnd - headingStart) * rise}px`);
    hero.style.setProperty('--hero-heading-scale', 1 - .025 * rise);
    hero.style.setProperty('--hero-line-progress', line);
    hero.style.setProperty('--hero-copy-progress', text);
    hero.style.setProperty('--hero-copy-offset', `${(1 - text) * 20}px`);
    hero.style.setProperty('--hero-cta-progress', action);
    hero.style.setProperty('--hero-cta-offset', `${(1 - action) * 12}px`);
    hero.style.setProperty('--hero-art-scale', scaleStart + (scaleEnd - scaleStart) * smooth(progress));
    hero.style.setProperty('--hero-art-opacity', mobile ? smooth(range(progress, .02, .8)) : 1);
    page.style.setProperty('--hero-nav-opacity', header && mobile && geometry.animated ? 1 - smooth(range(progress, 0, .3)) : 1);
    if (header) header.inert = headerInert || (mobile && geometry.animated && progress > .98);
    if (scrollHint) {
      const travel = smooth(range(progress, .14, .96));
      hero.style.setProperty('--hero-scroll-cue-y', `${mobile ? hintStart + (hintEnd - hintStart) * travel : hintStart}px`);
      hero.style.setProperty('--hero-scroll-cue-opacity', 1 - smooth(range(progress, .02, .24)) + (mobile ? smooth(range(progress, .86, 1)) : 0));
      updateHint();
    }
    hero.dataset.heroProgress = progress.toFixed(4);
    copy.style.visibility = text > 0 ? 'visible' : 'hidden';
    copy.setAttribute('aria-hidden', String(text === 0));
    if (cta) { cta.style.visibility = action > 0 ? 'visible' : 'hidden'; cta.inert = action < .98; }
  }
  function openIntro() {
    page.dataset.heroIntroPlayed = 'true';
    window.AmbitionLoading?.skip?.('scroll');
    hero.dispatchEvent(new CustomEvent('ambition:hero-reveal'));
  }
  function finish() {
    cancelAnimationFrame(frame); frame = 0;
    clearTimeout(holdTimer); holdTimer = 0;
    progress = 1; state = 'done';
    page.dataset.heroRevealHeld = 'true';
    hero.dataset.revealPause = state;
    openIntro();
    paint();
  }
  function tick(time) {
    frame = 0;
    if (state !== 'arriving' && state !== 'returning') return;
    const returning = state === 'returning';
    const target = returning ? 0 : 1;
    const amount = clamp((time - arrivalStart) / (returning ? 420 : 320), 0, 1);
    progress = transitionFrom + (target - transitionFrom) * amount;
    if (amount === 1) progress = target;
    paint();
    if (amount < 1) frame = requestAnimationFrame(tick);
    else if (returning) {
      state = 'idle'; hero.dataset.revealPause = state;
      delete page.dataset.heroRevealHeld;
    }
    else {
      state = 'holding'; hero.dataset.revealPause = state;
      holdTimer = setTimeout(finish, 200);
    }
  }
  function begin() {
    if (!['idle', 'returning'].includes(state) || !geometry?.animated || context.signal.aborted) return;
    cancelAnimationFrame(frame); clearTimeout(holdTimer); holdTimer = 0;
    transitionFrom = progress;
    state = 'arriving'; hero.dataset.revealPause = state;
    page.dataset.heroRevealHeld = 'true';
    openIntro();
    arrivalStart = performance.now();
    frame = requestAnimationFrame(tick);
  }
  function returnToStart() {
    if (!geometry?.animated || !atTop() || state === 'idle' || state === 'returning' || context.signal.aborted) return;
    cancelAnimationFrame(frame); clearTimeout(holdTimer); holdTimer = 0;
    if (copy.contains(document.activeElement)) {
      focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
    }
    transitionFrom = progress;
    state = 'returning'; hero.dataset.revealPause = state;
    delete page.dataset.heroRevealHeld;
    arrivalStart = performance.now();
    frame = requestAnimationFrame(tick);
  }
  function updateHint() {
    if (!geometry) return;
    const offset = scrollY - geometry.start;
    hero.dataset.scrollHintActive = String(!document.hidden && offset > -geometry.height && offset < geometry.height && (geometry.mobile || progress < .24));
  }
  function measure() {
    const width = hero.clientWidth, viewportHeight = innerHeight;
    const mobile = width <= 700, tablet = width > 700 && width < 1100;
    const animated = !editing && !motion.matches && viewportHeight >= 600 && !hero.hasAttribute('data-editor-selected');
    const headingHeight = heading.offsetHeight, copyHeight = copy.offsetHeight;
    const gap = mobile ? 24 : clamp(viewportHeight * .028, 24, 32);
    const lineHeight = mobile ? clamp(viewportHeight * .055, 36, 48) : clamp(viewportHeight * .075, 56, 84);
    const contentHeight = headingHeight + gap + lineHeight + gap + copyHeight;
    let headingEnd = Math.max(32, (viewportHeight - contentHeight) / 2), lineTop;
    if (mobile || tablet) {
      headingEnd = mobile ? clamp(viewportHeight * .07, 32, 80) : 80;
      const photoHeight = mobile ? width * 1.03 : width * 970 / 1920 * .95;
      lineTop = Math.max(headingEnd + headingHeight + gap, Math.min(photoHeight, viewportHeight * (mobile ? .47 : .52)));
    }
    if (!animated) headingEnd = Math.max(headingEnd, (header?.offsetHeight || 0) + 28);
    lineTop = Math.max(lineTop || 0, headingEnd + headingHeight + gap);
    if (mobile) lineTop = Math.max(headingEnd + headingHeight + gap, lineTop - 40);
    if (mobile && width <= 350 && viewportHeight <= 660) lineTop += 10;
    const copyTop = lineTop + lineHeight + gap;
    const hintHeight = mobile && scrollHint ? scrollHint.offsetHeight : 0;
    const cueGap = mobile ? (viewportHeight <= 740 ? 32 : 40) : 24;
    const hintEnd = copyTop + copyHeight + cueGap;
    const headingStart = (viewportHeight - headingHeight) / 2;
    const hintStart = headingStart + headingHeight + cueGap;
    const height = Math.max(viewportHeight, hintHeight ? hintEnd + hintHeight + 36 : copyTop + copyHeight + 48);
    const aspect = width / height, sourceAspect = 1920 / 970;
    const coverScale = Math.max(sourceAspect / aspect, aspect / sourceAspect);
    const scaleEnd = mobile || tablet ? 1 : Math.min(coverScale, 1.14) + .002;
    const scaleStart = !animated ? scaleEnd : Math.min(scaleEnd * 1.025, 1.162);
    hero.style.setProperty('--hero-stage-height', `${height}px`);
    hero.style.setProperty('--hero-scroll-distance', '0px');
    hero.style.setProperty('--hero-line-top', `${lineTop}px`);
    hero.style.setProperty('--hero-line-height', `${lineHeight}px`);
    hero.style.setProperty('--hero-copy-top', `${copyTop}px`);
    hero.dataset.heroMode = animated ? 'scroll' : 'static';
    geometry = { start: hero.getBoundingClientRect().top + scrollY, height, headingEnd, headingStart, mobile, animated, scaleStart, scaleEnd, hintStart, hintEnd };
    if (!animated) finish();
    else paint();
    updateHint();
  }
  const field = event => event.target?.closest?.('input, textarea, select, [contenteditable="true"], iframe, dialog[open], [aria-modal="true"]');
  function down(event, delta) {
    if (!event.isTrusted || !delta) return;
    if (event.ctrlKey || event.metaKey || event.altKey || field(event)) { if (active()) finish(); return; }
    const now = performance.now(), separateGesture = now - lastInput > 160;
    lastInput = now;
    if (delta < 0) {
      if (atTop() && geometry?.animated) {
        if (now - lastUpInput > 180) upwardDistance = 0;
        upwardDistance += -delta; lastUpInput = now;
        if (upwardDistance >= 8) returnToStart();
      }
      else if (active()) finish();
      return;
    }
    upwardDistance = 0;
    if (state === 'done' || !geometry?.animated) return;
    if (active() && separateGesture && progress >= .8) { finish(); return; }
    if (!event.cancelable) { finish(); return; }
    event.preventDefault();
    if (state === 'idle' || state === 'returning') begin();
  }
  context.listen(window, 'wheel', event => {
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || event.shiftKey) return;
    const scale = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? innerHeight : 1;
    down(event, event.deltaY * scale);
  }, { passive: false });
  context.listen(document, 'touchstart', event => {
    if (event.touches.length !== 1 || field(event)) { touch = null; if (active()) finish(); return; }
    if (active()) finish();
    upwardDistance = 0;
    touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
  }, { passive: true });
  context.listen(document, 'touchmove', event => {
    if (!touch || event.touches.length !== 1) { if (active()) finish(); return; }
    const point = event.touches[0], delta = touch.y - point.clientY, dx = touch.x - point.clientX;
    touch = { x: point.clientX, y: point.clientY };
    if (Math.abs(dx) > Math.abs(delta)) return;
    down(event, delta);
  }, { passive: false });
  context.listen(document, 'touchend', () => { touch = null; }, { passive: true });
  context.listen(document, 'touchcancel', () => { touch = null; if (active()) finish(); }, { passive: true });
  context.listen(document, 'keydown', event => {
    if (event.key === 'Home' && atTop() && !field(event)) { returnToStart(); return; }
    if (['Escape', 'Tab', 'Home', 'End'].includes(event.key)) { finish(); return; }
    if (event.key === ' ' && event.target?.closest?.('a[href], button')) { if (active()) finish(); return; }
    const delta = event.key === 'ArrowDown' ? 40 : event.key === 'PageDown' || (event.key === ' ' && !event.shiftKey) ? innerHeight : ['ArrowUp', 'PageUp'].includes(event.key) || (event.key === ' ' && event.shiftKey) ? -40 : 0;
    down(event, delta);
  }, { passive: false });
  context.listen(window, 'scroll', () => {
    const current = scrollY;
    if (current < previousScroll - .5 && atTop()) returnToStart();
    else if (active() || (state === 'idle' && current > previousScroll + .5) || (state === 'returning' && !atTop())) finish();
    previousScroll = current;
    updateHint();
  }, { passive: true });
  context.listen(document, 'click', event => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor) return;
    const url = new URL(anchor.href, location.href);
    if (url.origin === location.origin && url.pathname === location.pathname && url.hash === '#inicio' && atTop()) returnToStart();
    else finish();
  }, { capture: true });
  context.listen(document, 'focusin', event => { if (!hero.contains(event.target)) finish(); });
  context.listen(window, 'resize', measure);
  context.listen(window, 'pageshow', event => { if (event.persisted) finish(); measure(); });
  context.listen(window, 'hashchange', () => { if (location.hash === '#inicio' && atTop()) returnToStart(); else finish(); });
  context.listen(document, 'visibilitychange', () => { if (document.hidden) finish(); else measure(); updateHint(); });
  context.listen(motion, 'change', measure);
  context.listen(document, 'ambition:editor-state', measure);
  context.listen(document, 'ambition:dock-resize', measure);
  const observer = new ResizeObserver(() => { if (!context.signal.aborted) measure(); });
  observer.observe(heading); observer.observe(copy);
  if (scrollHint) observer.observe(scrollHint);
  document.fonts.ready.then(() => { if (!context.signal.aborted) measure(); });
  context.cleanup(() => {
    cancelAnimationFrame(frame); clearTimeout(holdTimer);
    if (state === 'idle' || state === 'returning') delete page.dataset.heroRevealHeld;
    else page.dataset.heroRevealHeld = 'true';
    observer.disconnect(); touch = null;
    page.classList.remove('has-hero-scroll');
    page.style.removeProperty('--hero-nav-opacity');
    if (header) header.inert = headerInert;
    if (focusTargetTabindex == null) focusTarget.removeAttribute('tabindex');
    else focusTarget.setAttribute('tabindex', focusTargetTabindex);
    hero.removeAttribute('data-scroll-hint-active');
    copy.style.visibility = ''; copy.removeAttribute('aria-hidden');
    if (cta) { cta.style.visibility = ''; cta.inert = false; }
  });
  measure();
});
